import { ComponentProps, Suspense } from 'react';
import { GLOBALS } from 'utils/generic/global-variables';
import { lazy } from 'utils/generic/lazy';

const { BetslipRootProvider } = lazy(
  () =>
    import(
      /* webpackChunkName: "betslip-root-provider"*/ 'newelements/_Betslip/providers'
    )
);

const { BetslipComponent } = lazy(
  () =>
    import(
      /* webpackChunkName: "betslip-element"*/ 'newelements/_Betslip/component'
    )
);

export const Betslip = (props: ComponentProps<typeof BetslipComponent>) => {
  if (window.fromNext) {
    GLOBALS.mounted.betslip = true;
  }

  return (
    <Suspense>
      <BetslipRootProvider>
        <BetslipComponent {...props} />
      </BetslipRootProvider>
    </Suspense>
  );
};
